import Vue from 'vue';
import {ValidationProvider, ValidationObserver, extend, setInteractionMode} from 'vee-validate';
import {required, email, min, confirmed, oneOf} from 'vee-validate/dist/rules';
import { localize } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import ca from 'vee-validate/dist/locale/zh_CN.json';
import ko from 'vee-validate/dist/locale/ko.json';
setInteractionMode('eager');

const vendor_code_from = {
    en: {},
    ko: {},
};

for (let i = 0; i < 100; i++) {
    const key = `edit-form-vendor-code-${i}`;
    vendor_code_from.en[key] = 'Vendor Code';
    vendor_code_from.ko[key] = '업체코드';
}


localize({
    en: {
        ...en,
        names: {
            // form item 
            'edit-form-accuracy': 'AI Assessment Accuracy',
            'edit-form-report-content': 'Report Content',
            'edit-form-company': 'Company',
            'edit-form-username': 'User Name',
            'edit-form-email': 'E-mail',
            'edit-form-password': 'Password',
            'edit-form-password-check': 'Password Check',
            'edit-form-company-name': 'Company Name',
            'edit-form-company-name-en': 'Company Name (English)',
            'edit-form-client': 'Client',
            'edit-form-country': 'Country',
            'edit-form-country-en': 'Country (English)',
            'edit-form-eco-vadis': 'EcoVadis',
            'edit-form-project-code': 'Project Code',
            'edit-form-period': 'Period',
            'edit-form-group-name': 'Group Name',
            'edit-form-group-name-en': 'Group Name (English)',
            'edit-form-start-date': 'Start Date',
            'edit-form-end-date': 'End Date',
            'edit-form-target-end-date': 'Target End Date',
            'edit-form-manager': 'Manager',
            'edit-form-hd-corporate': 'HD Corporate',
            ...vendor_code_from.en
        },
        messages: {
            ...en.messages,
            'YYYY-MM-DD': 'The {_field_} field must be in the format YYYY-MM-DD.',
            'rating_required': 'The {_field_} field is required.'
        }
    },
    ko: {
        ...ko,
        names: {
            // form item
            'edit-form-report-content': '리포트 내용',
            'edit-form-accuracy': 'AI 평가 정확도',
            'edit-form-company': '기업',
            'edit-form-username': '사용자명',
            'edit-form-email': '이메일',
            'edit-form-password': '비밀번호',
            'edit-form-password-check': '비밀번호 확인',
            'edit-form-company-name': '기업명',
            'edit-form-company-name-en': '기업명 (영문)',
            'edit-form-client': '원청사 유무',
            'edit-form-country': '국가',
            'edit-form-country-en': '국가 (영문)',
            'edit-form-eco-vadis': '에코바디스',
            'edit-form-project-code': '프로젝트 코드',
            'edit-form-period': '기간',
            'edit-form-group-name':'그룹명',
            'edit-form-group-name-en':'그룹명 (영문)',
            'edit-form-start-date': '시작일',
            'edit-form-end-date': '종료일',    
            'edit-form-target-end-date': '목표 종료일',
            'edit-form-manager': '매니저',
            'edit-form-hd-corporate': 'HD Corporate',
            ...vendor_code_from.ko
        },
        messages: {
            ...ko.messages,
            'YYYY-MM-DD': '{_field_} 항목은 YYYY-MM-DD 형식이어야 합니다.',
            'rating_required': '{_field_} 항목은 필수 정보입니다.'
        }
    },
    ca: {
        ...ca,
        names: {
          
        }  
    }
});

extend('required', {
    ...required,
});

extend('email', {
    ...email,
});

extend('min', {
    ...min,
});

extend('oneOf', {
    ...oneOf,
});

extend('confirmed', {
    ...confirmed,
});
extend('YYYY-MM-DD', {
    validate: (value) => {
        const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
        return regex.test(value);
    },
});

extend('rating_required', {
    validate: (value) => {
        return value != null && value > 0;
    },
});

localize('ko');

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
